import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { AuthProvider } from "@/context/AuthContext";
import { Toaster } from "sonner";
import ProtectedRoute from "@/components/ProtectedRoute";
import Login from "@/pages/Login";
import Signup from "@/pages/Signup";
import Dashboard from "@/pages/Dashboard";
import Inbox from "@/pages/Inbox";
import Contacts from "@/pages/Contacts";
import Templates from "@/pages/Templates";
import Cadences from "@/pages/Cadences";
import Integrations from "@/pages/Integrations";
import Team from "@/pages/Team";
import "@/App.css";

const TOAST_OPTIONS = {
  style: {
    background: "#0A0A0A",
    border: "1px solid rgba(255,255,255,0.15)",
    borderRadius: 2,
    color: "#fff",
    fontFamily: "'Satoshi', system-ui, sans-serif",
  },
};

function App() {
  return (
    <div className="App">
      <AuthProvider>
        <Toaster position="top-right" theme="dark" toastOptions={TOAST_OPTIONS} />
        <BrowserRouter>
          <Routes>
            <Route path="/" element={<Navigate to="/dashboard" replace />} />
            <Route path="/login" element={<Login />} />
            <Route path="/signup" element={<Signup />} />
            <Route path="/dashboard" element={<ProtectedRoute><Dashboard /></ProtectedRoute>} />
            <Route path="/inbox" element={<ProtectedRoute><Inbox /></ProtectedRoute>} />
            <Route path="/contacts" element={<ProtectedRoute><Contacts /></ProtectedRoute>} />
            <Route path="/templates" element={<ProtectedRoute><Templates /></ProtectedRoute>} />
            <Route path="/cadences" element={<ProtectedRoute><Cadences /></ProtectedRoute>} />
            <Route path="/integrations" element={<ProtectedRoute><Integrations /></ProtectedRoute>} />
            <Route path="/team" element={<ProtectedRoute><Team /></ProtectedRoute>} />
          </Routes>
        </BrowserRouter>
      </AuthProvider>
    </div>
  );
}

export default App;
